(function () {
  function normalisePhone(input) {
    input.value = String(input.value || '').replace(/\D/g, '').slice(0, 11);
    return input.value;
  }

  function isObviouslyDummy(number) {
    return /^0\d(\d)\1{8}$/.test(number) ||
      number === '01234567890' ||
      number === '07123456789' ||
      number === '07987654321' ||
      /^07700900\d{3}$/.test(number);
  }

  function validatePhone(input) {
    var number = normalisePhone(input);
    var valid = number === '' || (/^0[1-9]\d{9}$/.test(number) && !isObviouslyDummy(number));
    input.setCustomValidity(valid ? '' : (input.dataset.abPhoneInvalid || 'Please enter a valid 11-digit UK phone number.'));
    return valid;
  }

  function updateReferral(select) {
    var form = select.closest('form');
    if (!form) return;
    var otherWrap = form.querySelector('[data-ab-referral-other]');
    var otherInput = form.querySelector('[data-ab-referral-other-input]');
    if (!otherWrap || !otherInput) return;
    var showOther = select.value === 'Other';
    otherWrap.hidden = !showOther;
    otherInput.disabled = !showOther;
    otherInput.required = showOther;
    if (!showOther) otherInput.value = '';
  }

  function bind(root) {
    root.querySelectorAll('[data-ab-phone]:not([data-ab-validation-bound])').forEach(function (input) {
      input.dataset.abValidationBound = 'true';
      input.addEventListener('input', function () { validatePhone(input); });
      input.addEventListener('blur', function () { validatePhone(input); });
      var form = input.closest('form');
      if (form && !form.dataset.abPhoneValidationBound) {
        form.dataset.abPhoneValidationBound = 'true';
        form.addEventListener('submit', function (event) {
          var phone = form.querySelector('[data-ab-phone]');
          if (phone && !validatePhone(phone)) {
            event.preventDefault();
            phone.reportValidity();
            phone.focus();
          }
        });
      }
    });

    root.querySelectorAll('[data-ab-referral]:not([data-ab-referral-bound])').forEach(function (select) {
      select.dataset.abReferralBound = 'true';
      updateReferral(select);
      select.addEventListener('change', function () { updateReferral(select); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();